import { Component, ElementRef, OnInit, ViewChild, ViewChildren } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { Subject } from 'rxjs';
import { ErrorReportService } from 'src/services/error-report.service';
import { HttpService } from 'src/services/http.service';
import { CurriculoDialogComponent } from './curriculo-dialog/curriculo-dialog.component';
import { trigger } from '@angular/animations';
import { environment } from 'src/environments/environment';
import { CurriculoAlertComponent } from './curriculo-alert/curriculo-alert.component';

@Component({
  selector: 'app-curriculo',
  templateUrl: './curriculo.component.html',
  styleUrls: ['./curriculo.component.scss']
})
export class CurriculoComponent implements OnInit {

  @ViewChild('curriculoUpload', { static: false }) curriculoUpload: ElementRef

  submiting: boolean = false;
  previewUpload: any = null
  curriculo: any;
  downloadLink: string;

  constructor(
    private http: HttpService,
    private errorReport: ErrorReportService,
    private dialog: MatDialog
  ) { }

  ngOnInit(): void {

    const subject: Subject<any> = new Subject<any>();
    subject.subscribe((result: any) => {
      const { trigger, scope } = result;
      if (scope.indexOf('curriculo') > -1)
        this.submiting = trigger == 'pre';

    })

    this.http.setLoadingIndicator(subject, 'curriculo');
    this.getCurriculo();
  }

  openUpload() {
    this.curriculoUpload.nativeElement.click();
  }

  changeFile({ target }: any) {

    const { files: [file] } = target;

    if (file.type != 'application/pdf') {
      alert('Por favor, informe somente arquivos PDF!');
      return;
    }

    this.previewUpload = {
      name: file.name
    }

    const fReader = new FileReader();
    fReader.onload = (() => {

      const user = JSON.parse(localStorage.getItem('token'));
      const data = { curriculo: file, userId: user.id };

      this.http.save('curriculo', data)
        .subscribe({
          next: (result: any) => {
            // console.log(result);
            const { data } = result;
            const options = {
              disabledClose: true,
              width: '800px',
              data
            }

            this.dialog.open(CurriculoDialogComponent, options);
            this.curriculoUpload.nativeElement.value = '';
            this.previewUpload = null
            this.getCurriculo();

          },
          error: (err: any) => {
            this.errorReport.showMessage(err);
            this.curriculoUpload.nativeElement.value = '';
            this.previewUpload = null
          }
        })

    })
    fReader.readAsDataURL(file)

  }

  linkDownload() {
    const user = JSON.parse(localStorage.getItem('token'));
    const data = { userId: user.id };

    this.http.get('curriculo:verify-download', data)
      .subscribe(
        (result: any) => {
          if (result.data.empty.length == 0) {
            window.open(`${environment.apiEndpoint}?action=curriculo:download&userId=${user.id}`);
          } else {
            const options = {
              width: '800px',
              disabledClose: true,
              data: result.data
            }
            this.dialog.open(CurriculoAlertComponent, options)
              .afterClosed()
              .subscribe((result: boolean) => {
                if (result)
                  window.open(`${environment.apiEndpoint}?action=curriculo:download&userId=${user.id}`);
              })
          }
        }
      )

  }

  getCurriculo() {

    const user = JSON.parse(localStorage.getItem('token'));;
    const data = { id: user.id };

    this.http.get('curriculo', data)
      .subscribe(
        (result: any) => {
          this.curriculo = result.data;
        },
        (err: any) => {
          this.errorReport.showMessage(err);
        }
      )

  }

}